import React from 'react';
const StatusBadge = _ref => {
  let {
    status,
    categoryTitle
  } = _ref;
  const base = {
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    border: '2px solid #fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  if (status === 'completed') return /*#__PURE__*/React.createElement("div", {
    style: {
      ...base,
      background: '#10B981'
    },
    "data-testid": `icon-${categoryTitle}-badge-success`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '10px',
      color: '#fff'
    }
  }, "check"));
  if (status === 'in_progress') return /*#__PURE__*/React.createElement("div", {
    style: {
      ...base,
      background: '#F59E0B'
    },
    "data-testid": `icon-${categoryTitle}-badge-in_progress`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '10px',
      color: '#fff'
    }
  }, "more_horiz"));
  if (status === 'not_started') return /*#__PURE__*/React.createElement("div", {
    style: {
      ...base,
      background: '#E5E7EB'
    },
    "data-testid": `icon-${categoryTitle}-badge-not_started`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '10px',
      color: '#9CA3AF'
    }
  }, "remove"));
  return null;
};
export default StatusBadge;